import React from 'react'
import axios from '@/utils/myAxios'
import moment from 'moment'
import Cookie from 'js-cookie'
import { Link } from 'react-router-dom'
import {
    Button,
    Table,
    Pagination,
    Modal,
    message,
    Radio,
    InputNumber,
    Input,
    Select,
    Form,
    List,
} from 'antd'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import { RSA } from '@/utils/rsa'

// 表单数据
const formData = {
    uid: undefined,
}

export default class IpGpsWhitelist extends React.Component {
    state = {
        loading: false, // 是否加载中
        show: false, // 是否显示弹窗
        type: undefined, // 操作类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            uid: undefined,
        },
        data: [], // 表格数据
        formData: { ...formData }, // 表单数据
    }

    componentDidMount () {
        this.fetchData()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios.get('/v1/api/whitelist/list', {
            params: {
                ...this.state.queryParams,
                total: undefined,
            },
        }).then((res) => {
            this.setState({
                loading: false,
                queryParams: { ...this.state.queryParams, total: res.count || 0 },
                data: res.data || [],
            })
        })
    }

    /**
     * 删除数据
     */
    handleDelete = (item) => {
        Modal.confirm({
            title: this.props.language['hint'],
            content: this.props.language['deleteConfirm'],
            onOk: () => {
                axios
                    .delete(`/v1/api/whitelist/remove/${item.uid}`)
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                this.props.language['deleteSuccessMessage']
                            )
                            this.fetchData()
                        }
                    })
            },
        })
    }

    /**
     * 添加数据
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'add') {
                    // 添加
                    axios
                        .get('/v1/api/union_select_user', {
                            params: {
                                user_id: values.uid,
                            },
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                axios
                                    .post(`/v1/api/whitelist/add/${values.uid}`)
                                    .then((res) => {
                                        if (res.code === 1) {
                                            message.success(
                                                this.props.language[
                                                'addSuccessMessage'
                                                ]
                                            )
                                            this.handleClose()
                                            this.fetchData()
                                        }
                                    })
                            }
                        })
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = async (type, item) => {
        if (type === 'add') {
            // 添加
            this.setState({
                type,
                show: true,
                title: this.props.language['addWhitelist'],
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false, formData: { ...formData } });
    }

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    uid: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["playerIdPlaceholder"]}
                        value={this.state.queryParams.uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("uid", value)
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    {(Cookie.get('unionType') === 'super_union' || Cookie.get('unionType') === 'super_union_vip') && (
                        <Button
                            type="primary"
                            ghost
                            onClick={() => this.handleShow('add')}
                        >
                            {this.props.language['addWhitelist']}
                        </Button>
                    )}
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) => `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language['playerId']}
                            dataIndex="uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['playerName']}
                            dataIndex="name"
                        />
                        {(Cookie.get('unionType') === 'super_union' || Cookie.get('unionType') === 'super_union_vip') && (
                            <Table.Column
                                align="center"
                                title={this.props.language['operation']}
                                dataIndex=""
                                fixed={isMobileDevice() ? false : 'right'}
                                width={120}
                                render={(item) => (
                                    <>
                                        <Button
                                            type="danger"
                                            ghost
                                            onClick={() => this.handleDelete(item)}
                                        >
                                            {this.props.language['delete']}
                                        </Button>
                                    </>
                                )}
                            />
                        )}
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleAdd}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                    footer={
                        <>
                            <Button
                                type="default"
                                onClick={this.props.onCancel}
                            >
                                {this.props.language['cancel']}
                            </Button>
                            <Button
                                type="primary"
                                onClick={this.props.onOk}
                            >
                                {this.props.language['confirm']}
                            </Button>
                        </>
                    }
                >
                    <div className="container-content">
                        {/* 添加 */}
                        {(this.props.type === 'add' ||
                            this.props.type === 'edit') && (
                                <Form>
                                    <Form.Item
                                        label={this.props.language['playerId']}
                                    >
                                        {getFieldDecorator('uid', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'playerIdVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.uid,
                                        })(
                                            <InputNumber
                                                precision={0}
                                                min={0}
                                                max={100000000}
                                                disabled={
                                                    this.props.type === 'edit'
                                                }
                                                placeholder={
                                                    this.props.language[
                                                    'playerIdPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </Form>
                            )}
                    </div>
                </Modal>
            )
        }
    }
)
